<template>
  <vuescroll>
      <div class="box-border m-8">
        <Header>
          <template v-slot:title>Te Perdiste?</template>
          <template v-slot:subtitle>Vuelve al inicio</template>
        </Header>
        <div class="my-auto text-center">
          <div class="text-12xl">
            404
          </div>
          <div class="text-3xl">
            No sé que estabas buscando, pero te recomiendo volver al inicio <button @click="backHome" class="px-4 rounded-lg bg-letter-submenu text-quaternary hover:bg-secondary">aquí</button>
          </div>
        </div>
      </div>
  </vuescroll>
</template>

<script>
import vuescroll from "vuescroll";
import Header from '../components/Header'

export default {
  name: "Portfolio",
  components: {
    Header,
    vuescroll
  },
  methods: {
    backHome() {
      return this.$router.push({name: 'Home'});
    }
  }
};
</script>
